/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactpackalmostready3Inputs */

const en_artifactpackalmostready3 = /** @type {(inputs: Artifactpackalmostready3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almost ready — finalise these to unlock`)
};

const pt_artifactpackalmostready3 = /** @type {(inputs: Artifactpackalmostready3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quase pronto — finalize estes pontos para desbloquear`)
};

/**
* | output |
* | --- |
* | "Almost ready — finalise these to unlock" |
*
* @param {Artifactpackalmostready3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactpackalmostready3 = /** @type {((inputs?: Artifactpackalmostready3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactpackalmostready3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactpackalmostready3(inputs)
	return pt_artifactpackalmostready3(inputs)
});
export { artifactpackalmostready3 as "artifactPackAlmostReady" }